import React, { useMemo, useEffect, useState } from "react"

import { Container, CardBody, Card } from "reactstrap"

import Breadcrumb from "components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"

import { app_url } from "app_config"

import practice_logo from "../../../assets/images/users/profile.png"
import { deleteNow } from "helpers/delete_function"
import { axiosbaseurl } from "configure"
import moment from "moment"
import { setUpdatedData } from "helpers/data_setters"
import Loader from "components/Common/Loader"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"

const AllPracticeMasters = () => {

    const [table_data, settable_data] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getPractice = async () => {
            try {
                setLoading(true)
                const response = await axiosbaseurl.get("/practice-master");
                if (response.data.success) {
                    settable_data(response.data.data)
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        }
        getPractice()
    }, [])

    document.title = "Practice Master | Peacock Accountants Limited";

    return (
        <>
            {loading && <Loader />}

            <div className="page-content mb-5">
                <Container fluid >
                    <Breadcrumb
                        title={"Dashboard"}
                        breadcrumbItem={"Practice Master"}
                    />

                    <Card className="px-0 mx-0">
                        <CardBody >
                            <TableComponent table_data={table_data} settable_data={settable_data} />
                        </CardBody>
                    </Card>

                </Container>
            </div>
        </>
    )
}

const TableComponent = ({ table_data, settable_data }) => {

    const { checkAccess, permissions } = usePermissionData()
    const module_id = 5;

    const navigate = useNavigate()

    const handleStatus = async (status, id) => {
        try {
            if (status) {
                const response = await axiosbaseurl.patch(`/practice-master/${id}/status`, { status });
                if (response.data.success)
                    settable_data(prev => setUpdatedData(prev, response.data.data, "edit", "Status "));
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleDelete = async (id) => {
        try {
            const response = await axiosbaseurl.delete(`/practice-master/${id}`);
            if (response.data.success)
                settable_data(prev => setUpdatedData(prev, response.data.data, "delete"))

        } catch (error) {
            console.log(error)
            swal("", error.response.data.message || "Something went Wrong", "error")
        }
    }

    // columns
    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                filterable: true,
                disableFilters: true,
                className: "  text-center",
                Cell: cellProps => (<span>{cellProps.row.index + 1}</span>),
            },
            {
                Header: "Practice Logo",
                accessor: "logo",
                disableFilters: true,
                filterable: true,
                className: "text-center",
                Cell: cellProps => {
                    return (
                        <div className="text-center">
                            <img
                                src={cellProps.row.original?.practiceLogo ?
                                    `${process.env.REACT_APP_IMAGE_PATH}/${cellProps.row.original?.practiceLogo}`
                                    : practice_logo // Fallback to default image
                                }
                                alt="img"
                                className="rounded-circle"
                                width={35}
                                height={35}
                            />
                        </div>
                    )
                },
            },
            {
                Header: "Practice Name",
                accessor: "practiceName",
                disableFilters: true,
                filterable: true
            },
            {
                Header: "Practice Client Code",
                accessor: "practiceClientCode",
                disableFilters: true,
                // className: "text-center",
                filterable: true,
            },
            {
                Header: "Practice Email",
                accessor: "email",
                disableFilters: true,
                // className: "text-center",
                filterable: true,
            },
            {
                Header: "Created At",
                accessor: "createdAt",
                disableFilters: true,
                filterable: true,
                // className: " text-center",
                Cell: cellProps => {
                    return (
                        <span>{moment(cellProps.row.original.createdAt).format("DD MMM YYYY | hh:mm A")}</span>
                    )
                },
            },
            {
                Header: "Status",
        disableSort: true,
                accessor: "status",
                disableFilters: true,
                filterable: true,
                className: "text-center",
                Cell: cellProps => {
                    return (
                        <div className="text-center">
                            <select
                                onChange={(e) => handleStatus(e.target.value, cellProps.row.original.id)}
                                disabled={!checkAccess(module_id, "edit")}
                                className={`badge fs-6 border-0 status_select_dropdown 
                                bg-${cellProps.row.original.status == "Active" ? "green" : "danger"}`}
                                value={cellProps.row.original.status}>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                            </select>
                        </div>
                    )
                },
            },
            {
                Header: "Action",
                disableFilters: true,
                disableSort: true,
                accessor: "view",
                className: "col-2 text-center",
                Cell: cellProps => {
                    return (
                        <div>
                            {
                                checkAccess(module_id, 'edit') &&
                                <Link
                                    to={`${app_url}master/edit-practice-master/${cellProps.row.original.id}`}
                                    className="btn btn-success bg-green  btn-sm me-2"
                                >
                                    <i className="fas fa-pen me-1"></i> Edit
                                </Link>
                            }
                            {
                                checkAccess(module_id, 'remove') &&
                                <button
                                    onClick={() => deleteNow(() => handleDelete(cellProps.row.original.id))}
                                    className="btn btn-danger btn-sm ml-10"
                                >
                                    <i className="fas fa-trash-alt"></i>
                                </button>
                            }
                        </div>
                    )
                },
            },
        ],
        [permissions]
    )

    // table data
    const data = useMemo(() => (table_data), [table_data])

    return (
        <>
            <PermittedComponent isAccess={checkAccess(module_id, "view")}>

                <CommonTable
                    columns={columns}
                    data={data}
                    heading={"Practice Records"}
                >
                    <div>
                        {/* <button className="btn btn-success bg-green ms-4">
                            <i className="fas fa-download me-2"></i>
                            Export
                        </button> */}
                        {
                            checkAccess(module_id, 'add') &&
                            <Link to={`${app_url}master/add-practice-master`} className="btn btn-primary bg-blue ms-3">
                                <i className="fas fa-plus me-2"></i>
                                Add Practice
                            </Link>
                        }

                        <button onClick={() => navigate(-1)} className="btn btn-secondary bg-dark ms-3">
                            <i className="fas fa-arrow-left me-3"></i>
                            Back
                        </button>
                    </div>
                </CommonTable>

            </PermittedComponent>
        </>
    )
}

export default AllPracticeMasters
